/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { number, object, Schema } from '../schema';

export interface Meta {
  totalPages: number;
}

export const metaSchema: Schema<Meta> = object({
  totalPages: ['TotalPages', number()],
});
